export const formatExpiryDate = (isoDate: string): string | null => {
  const date = new Date(isoDate);

  if (isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString(undefined, {month: 'short', day: 'numeric', year: 'numeric'});
};

export const getRenewalCreditsText = (numCredits: number, renewalDate: string): string | null => {
  const formattedDate = formatExpiryDate(renewalDate);

  if (!formattedDate) {
    return null;
  }

  return window.i18next.t('pmwjs_x_credits_added_on_date_with_renewal', {numCredits: numCredits.toLocaleString(), date: formattedDate});
};
